import React, { useCallback } from "react"
import {
  Field,
  FieldArrayFieldsProps,
  WrappedFieldArrayProps,
  WrappedFieldProps,
} from "redux-form"
import styled from "styled-components"
import Color from "../../../../../../../style/enum/color"
import { Error } from "../../../../../../parts/form-error-string-wrapper"
import { AddButton, DeleteButton } from "../buttons"

export const QuestionInput = ({
  fields,
  meta: { error, submitFailed },
}: WrappedFieldArrayProps<string>) => {
  const add = useCallback(() => {
    fields.push("")
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      {fields.map((answer, index) => (
        <Field
          key={index}
          name={answer}
          type="text"
          fields={fields}
          index={index}
          component={PartialQuestionInput}
        />
      ))}
      {submitFailed && error && <Error>{error}</Error>}
      {fields.length < 5 && <AddButton onClick={add} />}
    </div>
  )
}

const PartialQuestionInput = (
  props: WrappedFieldProps & {
    fields: FieldArrayFieldsProps<string>
    index: number
  },
) => {
  return (
    <>
      <StyledField key={props.index}>
        {props.index + 1}.{" "}
        <input {...props.input} placeholder={"回答を入力してください"} />
        <DeleteButton onClick={() => props.fields.remove(props.index)} />
      </StyledField>
      {props.meta.submitFailed && props.meta.error && (
        <StyledError>{props.meta.error}</StyledError>
      )}
    </>
  )
}

const StyledField = styled.div`
  border-bottom: 1px solid ${Color.LIGHT_GRAY};
  color: ${Color.LIGHT_GRAY};
  padding: 4px 8px;
  margin: 16px 0;
  font-size: 0.8rem;
  display: flex;
  > input {
    padding-left: 8px;
    flex-grow: 1;
  }
`

const StyledError = styled(Error)`
  margin-top: -12px;
  margin-bottom: 12px;
`
